import { ButtonLoader } from "components";
import Admin2 from "layouts/Admin2";
import ClearBackendCache from "./ClearBackendCache";
import PublishRoles from "./PublishRoles";
import PublishPermissions from "./PublishPermissions";
import PublishConfigurations from "./PublishConfigurations";
import ReconcileEcocashOrders from "./ReconcileEcocashOrders";
import useGetServerDetails from "api/CommandCenterResource/useGetServerDetails";
import { FiRefreshCw, FiShield, FiLock, FiDollarSign } from "react-icons/fi";
import PageHeading from "admin/components/PageHeading";
import { BsTerminal } from "react-icons/bs";

const CommandCenter = () => {
	const { isLoading: isLoadingServerEnv } = useGetServerDetails();

	if (isLoadingServerEnv) {
		return (
			<Admin2>
				<div className="min-h-[60vh] flex justify-center items-center">
					<ButtonLoader size={60} />
				</div>
			</Admin2>
		);
	}

	// const envItems = data?.data;

	// const envs = data?.data
	// 	? Object.keys(data?.data)?.map((key) => ({
	// 			key: key,
	// 			value: envItems[key],
	// 	  }))
	// 	: [];

	return (
		<Admin2>
			<div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
				<div className="mb-8">
					<PageHeading title="Command Center" icon={<BsTerminal size={24} />} />

					<p className="mt-2 text-sm text-gray-600">Manage system commands and configurations</p>
				</div>

				<div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
					<div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 hover:shadow-md transition-shadow flex flex-col h-full">
						<div>
							<div className="flex items-center gap-3 mb-4">
								<FiRefreshCw className="text-indigo-600 text-xl" />
								<h3 className="text-lg font-semibold text-gray-900">Cache Management</h3>
							</div>
							<p className="text-sm text-gray-600">Clear backend cache to ensure fresh data</p>
							<div className="mb-4 flex flex-col text-xs">
								<code>php artisan config:cache</code>
								<code>php artisan route:cache</code>
								<code>php artisan view:cache</code>
							</div>
						</div>
						<div className="mt-auto">
							<ClearBackendCache />
						</div>
					</div>

					<div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 hover:shadow-md transition-shadow flex flex-col h-full">
						<div>
							<div className="flex items-center gap-3 mb-4">
								<FiShield className="text-indigo-600 text-xl" />
								<h3 className="text-lg font-semibold text-gray-900">Role Management</h3>
							</div>
							<p className="text-sm text-gray-600">Publish and update system roles</p>
							<div className="mb-4 flex flex-col text-xs">
								<code className="">php artisan publish:roles</code>
							</div>
						</div>
						<div className="mt-auto">
							<PublishRoles />
						</div>
					</div>

					<div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 hover:shadow-md transition-shadow flex flex-col h-full">
						<div>
							<div className="flex items-center gap-3 mb-4">
								<FiLock className="text-indigo-600 text-xl" />
								<h3 className="text-lg font-semibold text-gray-900">Permission Management</h3>
							</div>
							<p className="text-sm text-gray-600">Publish and update system permissions</p>
							<div className="mb-4 flex flex-col text-xs">
								<code className="">php artisan publish:permissions</code>
							</div>
						</div>
						<div className="mt-auto">
							<PublishPermissions />
						</div>
					</div>

					<div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 hover:shadow-md transition-shadow flex flex-col h-full">
						<div>
							<div className="flex items-center gap-3 mb-4">
								<FiRefreshCw className="text-indigo-600 text-xl" />
								<h3 className="text-lg font-semibold text-gray-900">Configuration Management</h3>
							</div>
							<p className="text-sm text-gray-600">Publish and update system configurations</p>
							<div className="mb-4 flex flex-col text-xs">
								<code className="">php artisan publish:configurations</code>
							</div>
						</div>
						<div className="mt-auto">
							<PublishConfigurations />
						</div>
					</div>

					<div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 hover:shadow-md transition-shadow flex flex-col h-full">
						<div>
							<div className="flex items-center gap-3 mb-4">
								<FiDollarSign className="text-indigo-600 text-xl" />
								<h3 className="text-lg font-semibold text-gray-900">Ecocash Order Recovery</h3>
							</div>
							<p className="text-sm text-gray-600">
								Reconcile failed Ecocash orders by checking their actual payment status. Recovers
								orders that were marked as failed but actually succeeded.
							</p>
							<div className="mb-4 flex flex-col text-xs">
								<code className="">php artisan orders:reconcile-ecocash</code>
							</div>
						</div>
						<div className="mt-auto">
							<ReconcileEcocashOrders />
						</div>
					</div>
				</div>
			</div>
		</Admin2>
	);
};

export default CommandCenter;
